"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
/**
 * Checks input value is numeric
 *
 * @param  {any}  n   Input number
 *
 * @return {boolean}
 */
function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
exports.isNumeric = isNumeric;
function merge(target, source, isNullOverride, isMergeArrays) {
    if (isNullOverride === void 0) { isNullOverride = true; }
    if (isMergeArrays === void 0) { isMergeArrays = true; }
    if (!source) {
        return target;
    }
    if (Array.isArray(source)) {
        if (!Array.isArray(target)) {
            throw new Error("Cannot merge array onto an object");
        }
        if (isMergeArrays === false) { // isMergeArrays defaults to true
            target.length = 0; // Must not change target assignment
        }
        for (var _i = 0, source_1 = source; _i < source_1.length; _i++) {
            var src = source_1[_i];
            target.push(lodash_1.clone(src));
        }
        return target;
    }
    var keys = Object.keys(source);
    for (var _a = 0, keys_1 = keys; _a < keys_1.length; _a++) {
        var key = keys_1[_a];
        var value = source[key];
        if (value && typeof value === "object") {
            if (!target[key] ||
                typeof target[key] !== "object" ||
                (Array.isArray(target[key]) !== Array.isArray(value)) ||
                value instanceof Date ||
                Buffer.isBuffer(value) ||
                value instanceof RegExp) {
                target[key] = exports.clone(value);
            }
            else {
                exports.merge(target[key], value, isNullOverride, isMergeArrays);
            }
        }
        else if (value !== null && value !== undefined) {
            target[key] = value;
        }
        else if (isNullOverride !== false) { // Defaults to true
            target[key] = value;
        }
    }
    return target;
}
exports.merge = merge;
//# sourceMappingURL=data.js.map